export default {
  searchIcon: 'w-15 h-15',
  default: 'default',
  header: 'header w-full flex flex-wrap bg-white fixed z-20 top-0 lg:h-80',
  container: 'mx-auto w-full pantene-menu-bar sm:py-17 sm:px-15 lg:p-0',
  headerWrapper: '',
  menuBar: {
    logoContainer: 'text-black justify-center align-center relative z-18',
    logoDiv: ' flex flex-wrap items-center lg:px-30',
    logoButton:
      'sm:w-12/12 md:w-12/12 lg:w-10p md:bg-transparent lg:pl-0 flex justify-center lg:justify-start logo-wrapper',
  },
  hambergerContainer: 'hambergerContainer',
  hambergerButton:
    'lg:hidden float-right mt-0 md:ml-15 absolute left-0 sm:top-0 md:top-10 mobile-menu-btn hambergerButton',
  hambergerBar: 'bg-black icon-bar1',
  navbarContainer:
    'hidden lg:flex w-8/12 lg:w-80p items-center font-HelveticaNeueLight text-12 justify-center fullMenuSection',
  navbarContainerMobile:
    'navbarContainerMobile lg:hidden absolute inset-0 z-20 overflow-y-auto items-center justify-center h-screen sm:w-9/12 lg:w-12/12 bg-white',
  navbarRow: 'navbarRow',
  navbarRowMobile: 'navbarRowMobile',
  navbarLeft: 'navbarLeft',
  navbarLeftMobile: 'navbarLeftMobile',
  navbarRight: 'navbarRight',
  navbarRightWrapper: 'navbarRightWrapper',
  divider: 'divider',
  dividernew : 'divider-new',
  ulWrapper: 'ulWrapper',
  closeicon: 'closeicon',
  searchicon: 'searchicon flex',
  searchform: 'searchform w-12/12 mx-auto before-none searchformcenter',
  searchField:
    'searchField sm:w-11/12 lg:w-6/12 text-black font-BebasNeueRegular text-20 lg:text-24 leading-24 tracking-0.72 mx-auto text-center',
  searchButton:
    'searchButton absolute py-10 px-12 bg-black sm:top-129 lg:top-63 rounded-full',
  searchContainer:
    'search fixed inset-0 bg-alpha-black-50 z-20 overflow-y-auto items-center justify-center h-screen',
  countryDiv:
    'flex flex-row-reverse text-black items-center searchHeader absolute lg:relative sm:pinr-5p md:pinr-2p lg:w-10p',
  countryContainer:
    'countryContainer absolute flex flex-row w-5/12 lg:w-auto align-center  flex flex-row-reverse',
  countryButton:
    'countryButton flex flex-row items-center userName',
  countryButtonText:
    'countryButtonText text-16 font-BebasNeueBold text-16 pr-5 ml-8 pl-8 border-l-1 border-solid border-black whitespace-nowrap lg:ml-20 lg:pl-20 lg:py-5',
    // 'countryButtonText text-12 md:text-13 font-BebasNeueBold lg:text-16 pr-5 ml-15 whitespace-nowrap lg:ml-20 lg:pl-0 lg:py-5',
  downArrow: 'downArrow',
  upArrow: 'upArrow',
  inputTextField:
    'inputTextField sm:w-11/12 lg:w-6/12 mx-auto text-white font-BebasNeueRegular text-24 leading-42 tracking-0.72 sm:text-center lg:text-left',
  loginContainer:
    'countryContainer flex-row w-5/12 lg:w-auto align-center sm:hidden lg:flex loginMainSec',
  loginButtonText:
    'countryButtonText text-12 md:text-13 font-BebasNeueRegular lg:text-16 pr-5 ml-15 border-l-1 border-solid border-greyLightGlow whitespace-nowrap lg:ml-20 lg:pl-20 lg:py-5',
  registerButtonText:
    'countryButtonText registerButtonText text-12 md:text-13 font-BebasNeueRegular ml-15 lg:text-16 p-10 whitespace-nowrap',
  sliderContainer: 'relative',
  loggedIn: 'logged-in',
  layoutHideClass: 'hidden',
  searchCloseDiv: 'relative h-full w-full',
};
